import { render, staticRenderFns, recyclableRender, components } from "./chooseExamType.vue?vue&type=template&id=56c673f5&scoped=true&"
var renderjs
import script from "./chooseExamType.vue?vue&type=script&lang=js&"
export * from "./chooseExamType.vue?vue&type=script&lang=js&"
import style0 from "./chooseExamType.vue?vue&type=style&index=0&id=56c673f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c673f5",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/chooseExamType.vue"
export default component.exports